class PDPStickyAddToCart {
  constructor() {
    this.sticky = document.querySelector('[data-sticky-atc]');

    if (!this.sticky) return;

    this.stickyButton = this.sticky.querySelector('[data-sticky-atc-button]');
    this.stickyMinus = this.sticky.querySelector('[data-sticky-atc-minus]');
    this.stickyPlus = this.sticky.querySelector('[data-sticky-atc-plus]');
    this.stickyQty = this.sticky.querySelector('[data-sticky-atc-qty]');
    this.stickyVariantTitle = this.sticky.querySelector('[data-sticky-atc-variant-title]');
    this.stickyImage = this.sticky.querySelector('[data-sticky-atc-image]');
    this.stickyPrice = this.sticky.querySelector('[data-sticky-atc-price]');
    this.stickyMemberPrice = this.sticky.querySelector('[data-sticky-atc-member-price]');
    this.stickyComparePrice = this.sticky.querySelector('[data-sticky-atc-compare-price]');
    this.stickyPriceWrapper = this.sticky.querySelector('.pdp-sticky-atc__price');
    this.quantity = 1;
    this.isAdding = false;
    this.vipDiscount = Number(this.sticky.dataset.vipDiscount || 0);
    this.addToBagText = this.sticky.dataset.addToBagText || 'Add to Bag';
    this.productJson = this.getProductJson();

    this.mainProductContainer = this.getMainProductContainer();
    this.productForm = this.getProductForm();
    this.productActions = this.getProductActions();
    this.mainAddButton = this.getMainAddButton();
    this.notifyButton = this.getNotifyButton();
    this.outOfStockButton = this.getOutOfStockButton();
    this.mainQuantity = this.getMainQuantity();
    this.mainQuantityMinus = this.getMainQuantityMinus();
    this.mainQuantityPlus = this.getMainQuantityPlus();
    this.optionsTarget = this.getOptionsTarget();
    this.selectTeasButton = this.getSelectTeasButton();
    this.mainButtonObserver = null;

    this.init();
  }

  init() {
    this.bindStickyVisibility();
    this.bindQuantityButtons();
    this.bindAddButton();
    this.bindMainQuantityObserver();
    this.bindVariantUpdates();
    this.bindPdpPriceObserver();
    this.bindMainButtonObserver();
    this.syncQuantityFromMain();
    this.syncCurrentVariant();
    this.updateButtonState();
  }

  getProductJson() {
    const jsonEl = document.querySelector('[data-sticky-atc-product-json]');

    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.warn('Sticky ATC product JSON parse error:', error);
      return null;
    }
  }

  getMainProductContainer() {
    return (
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('[data-main-product]') ||
      document.querySelector('.product') ||
      document.querySelector('main') ||
      document
    );
}

  refreshDynamicElements() {
    this.mainProductContainer = this.getMainProductContainer();
    this.productForm = this.getProductForm();
    this.productActions = this.getProductActions();
    this.mainAddButton = this.getMainAddButton();
    this.notifyButton = this.getNotifyButton();
    this.outOfStockButton = this.getOutOfStockButton();
    this.mainQuantity = this.getMainQuantity();
    this.mainQuantityMinus = this.getMainQuantityMinus();
    this.mainQuantityPlus = this.getMainQuantityPlus();
    this.optionsTarget = this.getOptionsTarget();
    this.selectTeasButton = this.getSelectTeasButton();
  }

  getProductForm() {
    const container = this.mainProductContainer || document;

    return (
      container.querySelector('form[action*="/cart/add"]') ||
      container.querySelector('hh-product-form form') ||
      container.querySelector('[data-product-form]') ||
      container.querySelector('.product-form form') ||
      null
    );
  }

  getProductBuyButtons() {
    const container = this.mainProductContainer || document;

    return (
      container.querySelector('.product-buy-buttons.product-form-template--21595304820925__main') ||
      container.querySelector('.product-buy-buttons') ||
      null
    );
  }

  getProductActions() {
    const container = this.mainProductContainer || document;

    return (
      container.querySelector('.product-form__actions') ||
      container.querySelector('.product-buy-buttons.product-form-template--21595304820925__main') ||
      container.querySelector('.product-buy-buttons') ||
      null
    );
  }

  getMainAddButton() {
    const container = this.mainProductContainer || document;
    const form = this.productForm;

    return (
      container.querySelector('.product-form__actions button[name="add"]') ||
      container.querySelector('.product-form__buttons button[name="add"]') ||
      container.querySelector('button[name="add"].cta__action-btn') ||
      form?.querySelector('button[name="add"]') ||
      form?.querySelector('[type="submit"][name="add"]') ||
      null
    );
  }

  getNotifyButton() {
    const productId = this.productJson?.id;
    const container = this.mainProductContainer || document;

    if (productId) {
      const notifyByProductId = document.querySelector(`#notify_${productId}`);

      if (notifyByProductId) {
        return notifyByProductId;
      }
    }

    return (
      container.querySelector('[id^="notify_"]') ||
      container.querySelector('[id^="bisModalBtn"] button') ||
      container.querySelector('.bis-cta__btn button') ||
      container.querySelector('.bis-cta__btn .cta__action-btn') ||
      null
    );
  }

  getOutOfStockButton() {
    const productId = this.productJson?.id;
    const container = this.mainProductContainer || document;

    if (productId) {
      const outOfStockByProductId = document.querySelector(`#out_of_stock_${productId}`);

      if (outOfStockByProductId) {
        return outOfStockByProductId;
      }
    }

    return (
      container.querySelector('[id^="out_of_stock_"]') ||
      container.querySelector('hh-button[disabled].bis-cta__btn') ||
      null
    );
  }

  getMainQuantity() {
    const container = this.mainProductContainer || document;
    const form = this.productForm;

    return (
      container.querySelector('.product-form__actions hh-quantity-input') ||
      container.querySelector('hh-quantity-input.quantity-selector__wrapper') ||
      container.querySelector('hh-quantity-input') ||
      form?.querySelector('[name="quantity"]') ||
      null
    );
  }

  getMainQuantityMinus() {
    return this.mainQuantity?.querySelector?.('button[name="minus"]') || null;
  }

  getMainQuantityPlus() {
    return this.mainQuantity?.querySelector?.('button[name="plus"]') || null;
  }

  getOptionsTarget() {
    const container = this.mainProductContainer || document;

    return (
      container.querySelector('.product-form__input') ||
      container.querySelector('[data-product-options]') ||
      container.querySelector('variant-radios') ||
      container.querySelector('variant-selects') ||
      container.querySelector('.product-form__actions') ||
      container.querySelector('.product__info-wrapper') ||
      this.productForm ||
      null
    );
  }

  getSelectTeasButton() {
    return (
      document.querySelector('#js-product-select-teas-cta') ||
      document.querySelector('.js-product-select-teas-cta') ||
      document.querySelector('.product-select-teas__cta') ||
      null
    );
  }

  hasSelectTeasCTA() {
    return Boolean(this.getSelectTeasButton());
  }

  bindStickyVisibility() {
    this.refreshDynamicElements();

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    /*
      On mobile, only use the real main CTA button as the trigger.
      Do not fallback to wrapper elements, because they can make the sticky ATC
      appear too early before the user actually scrolls past the original CTA.
    */
    const trigger = isMobile
    ? (
        this.mainAddButton ||
        this.notifyButton ||
        this.outOfStockButton ||
        this.getProductBuyButtons() ||
        this.productActions
      )
    : (
      this.mainAddButton ||
      this.notifyButton ||
      this.outOfStockButton ||
      this.productActions ||
      this.getProductBuyButtons()
    );

    const footer =
      document.querySelector('footer') ||
      document.querySelector('.footer') ||
      document.querySelector('[data-section-type="footer"]') ||
      document.querySelector('#shopify-section-footer');

    if (!trigger) {
      this.hideSticky();
      return;
    }

    let isTriggerVisible = false;
    let hasPassedTrigger = false;
    let isFooterVisible = false;

    const updateStickyState = () => {
      if (isFooterVisible) {
        this.hideSticky();
        return;
      }

      /*
        Mobile behavior:
        - Hide sticky initially.
        - Hide while the original CTA button is visible.
        - Show only after user scrolls down past the original CTA button.
      */
      if (isMobile) {
        if (isTriggerVisible) {
          this.hideSticky();
          return;
        }

        this.showSticky();
        return;
      }

      /*
        Desktop behavior keeps the original logic:
        hide when the trigger is visible, show when it is not visible.
      */
      if (isTriggerVisible) {
        this.hideSticky();
        return;
      }

      this.showSticky();
    };

    const checkTriggerPosition = () => {
      const triggerRect = trigger.getBoundingClientRect();

      isTriggerVisible = triggerRect.top < window.innerHeight && triggerRect.bottom > 0;

      /*
        This is the key mobile condition:
        Sticky should only appear after the CTA button has moved above the viewport.
      */
      hasPassedTrigger = triggerRect.bottom < 0;

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
      }

      updateStickyState();
    };

    checkTriggerPosition();

    const triggerObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        isTriggerVisible = entry.isIntersecting;
        checkTriggerPosition();
      },
      {
        root: null,
        threshold: 0,
      }
    );

    triggerObserver.observe(trigger);

    if (footer) {
      const footerObserver = new IntersectionObserver(
        () => {
          checkTriggerPosition();
        },
        {
          root: null,
          threshold: 0,
        }
      );

      footerObserver.observe(footer);
    }

    window.addEventListener('scroll', checkTriggerPosition, { passive: true });
    window.addEventListener('resize', checkTriggerPosition);
  }

  showSticky() {
    this.sticky.classList.add('is-visible');
    document.body.classList.add('has-sticky-atc');
  }

  hideSticky() {
    this.sticky.classList.remove('is-visible');
    document.body.classList.remove('has-sticky-atc');
  }

  bindQuantityButtons() {
    this.stickyMinus?.addEventListener('click', () => {
      if (this.isAdding) return;
      if (this.stickyMinus.disabled) return;
      if (this.quantity <= 1) return;

      this.quantity -= 1;
      this.updateStickyQuantity();
      this.syncMainQuantity(this.quantity);
    });

    this.stickyPlus?.addEventListener('click', () => {
      if (this.isAdding) return;
      if (this.stickyPlus.disabled) return;

      this.quantity += 1;
      this.updateStickyQuantity();
      this.syncMainQuantity(this.quantity);
    });
  }

  updateStickyQuantity() {
    if (!this.stickyQty) return;

    this.stickyQty.textContent = this.quantity;
  }

  setQuantityDisabled(isDisabled) {
    if (this.stickyMinus) {
      this.stickyMinus.disabled = isDisabled;
      this.stickyMinus.classList.toggle('is-disabled', isDisabled);
    }

    if (this.stickyPlus) {
      this.stickyPlus.disabled = isDisabled;
      this.stickyPlus.classList.toggle('is-disabled', isDisabled);
    }
  }

  syncMainQuantity(quantity) {
    this.refreshDynamicElements();

    const quantityInput =
      this.productForm?.querySelector('input[name="quantity"]') ||
      this.mainProductContainer?.querySelector('input[name="quantity"]') ||
      null;

    if (quantityInput) {
      quantityInput.value = quantity;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    if (this.mainQuantity?.setAttribute) {
      this.mainQuantity.setAttribute('value', String(quantity));
      this.mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  bindAddButton() {
    if (!this.stickyButton) return;

    this.stickyButton.addEventListener('click', () => {
      if (this.isAdding) return;

      this.refreshDynamicElements();

      if (this.needsOptionSelection()) {
        this.scrollToOptions();
        return;
      }

      const selectedVariant = this.getSelectedVariant();

      if (selectedVariant && selectedVariant.available === false) {
        this.notifyButton = this.getNotifyButton();

        if (this.notifyButton && !this.stickyButton.disabled) {
          this.notifyButton.click();
        }

        return;
      }

      if (this.stickyButton.disabled) return;
      if (this.mainAddButton?.disabled) return;
      if (this.mainAddButton?.getAttribute('aria-disabled') === 'true') return;

      this.handleAddToCart();
    });
  }

  handleAddToCart() {
    this.refreshDynamicElements();

    const selectedVariant = this.getSelectedVariant();

    if (selectedVariant && selectedVariant.available === false) {
      this.notifyButton = this.getNotifyButton();

      if (this.notifyButton) {
        this.notifyButton.click();
      }

      this.updateButtonState();
      return;
    }

    if (this.mainAddButton?.disabled || this.mainAddButton?.getAttribute('aria-disabled') === 'true') {
      this.updateButtonState();
      return;
    }

    this.setAddingState(true);

    if (this.mainAddButton) {
      this.mainAddButton.click();

      window.setTimeout(() => {
        this.setAddingState(false);
        this.updateButtonState();
      }, 3500);

      return;
    }

    if (this.productForm && typeof this.productForm.requestSubmit === 'function') {
      this.productForm.requestSubmit();

      window.setTimeout(() => {
        this.setAddingState(false);
        this.updateButtonState();
      }, 3500);

      return;
    }

    if (this.productForm) {
      this.productForm.submit();

      window.setTimeout(() => {
        this.setAddingState(false);
        this.updateButtonState();
      }, 3500);
    }
  }

  setAddingState(isAdding) {
    this.isAdding = isAdding;

    if (!this.stickyButton) return;

    if (isAdding) {
      this.stickyButton.disabled = true;
      this.stickyButton.classList.add('is-loading', 'is-disabled');
      this.stickyButton.classList.remove('is-notify', 'is-select-options');
      this.stickyButton.setAttribute('aria-busy', 'true');
      this.stickyButton.textContent = 'Adding...';
      this.setQuantityDisabled(true);
      return;
    }

    this.stickyButton.classList.remove('is-loading');
    this.stickyButton.removeAttribute('aria-busy');
  }

  bindMainQuantityObserver() {
    if (!this.mainQuantity) return;

    const observer = new MutationObserver(() => {
      this.syncQuantityFromMain();
    });

    observer.observe(this.mainQuantity, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.mainQuantity.addEventListener('change', () => {
      this.syncQuantityFromMain();
    });

    this.mainQuantity.addEventListener('input', () => {
      this.syncQuantityFromMain();
    });

    this.mainQuantity.addEventListener('quantity', () => {
      this.syncQuantityFromMain();
    });
  }

  syncQuantityFromMain() {
    const possibleInput =
      this.mainQuantity?.querySelector?.('input') ||
      this.productForm?.querySelector('input[name="quantity"]') ||
      this.mainProductContainer?.querySelector('input[name="quantity"]') ||
      null;

    if (possibleInput && possibleInput.value) {
      this.quantity = Math.max(1, parseInt(possibleInput.value, 10) || 1);
      this.updateStickyQuantity();
      return;
    }

    const valueAttr =
      this.mainQuantity?.getAttribute?.('value') ||
      this.mainQuantity?.getAttribute?.('quantity') ||
      this.mainQuantity?.getAttribute?.('initial');

    if (valueAttr) {
      this.quantity = Math.max(1, parseInt(valueAttr, 10) || 1);
      this.updateStickyQuantity();
    }
  }

  bindVariantUpdates() {
    document.addEventListener('change', (event) => {
        const target = event.target;

        if (!(target instanceof Element)) return;

        /*
        * Recharge / VIP controls are not product variant controls.
        * Do not call syncCurrentVariant() for them because updatePrice()
        * would overwrite the subscription/member price.
        */
        const isRechargeControl = Boolean(
          target.closest('.rc-container-wrapper') ||
          target.matches(
            '.rc_widget__option__input, ' +
            '.rc-selling-plans__dropdown, ' +
            '[name="selling_plan"]'
          )
        );

        const isVipPricingControl = Boolean(
          target.closest('[data-pdp-pricing-selector]') ||
          target.matches('[data-vip-price-option]')
        );

        if (isRechargeControl || isVipPricingControl) {
          requestAnimationFrame(() => {
            this.syncPriceFromPdp();

            window.setTimeout(
              () => this.syncPriceFromPdp(),
              100
            );

            window.setTimeout(
              () => this.syncPriceFromPdp(),
              300
            );
          });

          return;
        }

        if (
          target.matches('input[type="radio"]') ||
          target.matches('select') ||
          target.matches('input[name="id"]')
        ) {
          window.setTimeout(() => {
            this.refreshDynamicElements();
            this.syncCurrentVariant();
            this.updateButtonState();
            this.bindMainButtonObserver();
          }, 150);
        }
      });

    document.addEventListener('variant:change', (event) => {
      this.refreshDynamicElements();

      if (event.detail && event.detail.variant) {
        this.updateVariantFromEvent(event.detail.variant);
      } else {
        this.syncCurrentVariant();
      }

      this.updateButtonState();
      this.bindMainButtonObserver();
    });

    document.addEventListener('variantChange', (event) => {
      this.refreshDynamicElements();

      if (event.detail && event.detail.variant) {
        this.updateVariantFromEvent(event.detail.variant);
      } else {
        this.syncCurrentVariant();
      }

      this.updateButtonState();
      this.bindMainButtonObserver();
    });

    document.addEventListener('productAdded', () => {
      this.setAddingState(false);
      this.updateButtonState();
    });

    document.addEventListener('cart:updated', () => {
      this.setAddingState(false);
      this.updateButtonState();
    });

    document.addEventListener('cart:refresh', () => {
      this.setAddingState(false);
      this.updateButtonState();
    });

    document.addEventListener('cart:error', () => {
      this.setAddingState(false);
      this.updateButtonState();
    });
  }

  bindMainButtonObserver() {
    if (!this.mainAddButton) return;

    if (this.mainButtonObserver) {
      this.mainButtonObserver.disconnect();
    }

    this.mainButtonObserver = new MutationObserver(() => {
      if (this.isAdding) return;

      this.updateButtonState();
    });

    this.mainButtonObserver.observe(this.mainAddButton, {
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled'],
    });
  }

  syncCurrentVariant() {
    const selectedVariant = this.getSelectedVariant();

    if (selectedVariant) {
      this.updateVariantFromEvent(selectedVariant);
      return;
    }

    this.updateVariantTitle();
  }

  updateVariantTitle() {
    if (!this.stickyVariantTitle) return;

    const selectedText = this.getSelectedOptionText();

    if (selectedText) {
      this.stickyVariantTitle.textContent = selectedText;
    }
  }

  updateVariantFromEvent(variant) {
    if (!variant) return;

    if (this.stickyVariantTitle && variant.title && variant.title !== 'Default Title') {
      this.stickyVariantTitle.textContent = variant.title;
    }

    this.updatePrice(variant);
    this.updateImage(variant);
  }

  getSelectedVariant() {
    const variantInput =
      this.productForm?.querySelector('input[name="id"]') ||
      this.mainProductContainer?.querySelector('input[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (variantInput?.value && this.productJson?.variants?.length) {
      const matchedVariant = this.productJson.variants.find((variant) => {
        return String(variant.id) === String(variantInput.value);
      });

      if (matchedVariant) return matchedVariant;
    }

    const selectedOptions = this.getSelectedOptions();

    if (!selectedOptions.length || !this.productJson?.variants?.length) {
      return null;
    }

    return this.productJson.variants.find((variant) => {
      return selectedOptions.every((option, index) => {
        return variant.options[index] === option;
      });
    }) || null;
  }

  getSelectedOptions() {
    const container = this.mainProductContainer || document;

    const checkedRadios = container.querySelectorAll(
      '.product-form__input input[type="radio"]:checked, input[type="radio"][name^="options"]:checked, input[type="radio"][name^="option"]:checked'
    );

    if (checkedRadios.length) {
      return Array.from(checkedRadios)
        .map((radio) => radio.value)
        .filter(Boolean);
    }

    const selects = container.querySelectorAll(
      'select[name^="options"], select[name^="option"]'
    );

    if (selects.length) {
      return Array.from(selects)
        .map((select) => select.value)
        .filter(Boolean);
    }

    return [];
  }

  getSelectedOptionText() {
    return this.getSelectedOptions().join(' / ');
  }

  isGiftProduct() {
  const productType = String(this.productJson?.type || '').toLowerCase().trim();

  return productType === 'gift card';
}

hideStickyPrices() {
  if (this.stickyPriceWrapper) {
    this.stickyPriceWrapper.classList.add('hidden');
    this.stickyPriceWrapper.style.display = 'none';
  }

  if (this.stickyPrice) {
    this.stickyPrice.textContent = '';
    this.stickyPrice.classList.add('hidden');
  }

  if (this.stickyMemberPrice) {
    this.stickyMemberPrice.textContent = '';
    this.stickyMemberPrice.classList.add('hidden');
  }

  if (this.stickyComparePrice) {
    this.stickyComparePrice.textContent = '';
    this.stickyComparePrice.classList.add('hidden');
  }
}

  updatePrice(variant) {
  if (this.isGiftProduct()) {
    this.hideStickyPrices();
    return;
  }

  if (!variant || typeof variant.price === 'undefined') return;

  const price = Number(variant.price);
  const compareAtPrice = Number(variant.compare_at_price || 0);
  const isOnSale = compareAtPrice > price;

  const memberDiscount = 100 - this.vipDiscount;
  const memberPrice = Math.round((price * memberDiscount) / 100);

  const regularCompareEl = this.sticky?.querySelector(
    '.pdp-sticky-atc__regular-compare-price'
  );

  const regularCurrentEl = this.sticky?.querySelector(
    '.pdp-sticky-atc__regular-current-price'
  );

  const memberCompareEl = this.sticky?.querySelector(
    '.pdp-sticky-atc__member-compare-price'
  );

  const memberCurrentEl = this.sticky?.querySelector(
    '.pdp-sticky-atc__member-current-price'
  );

  /*
   * Regular Price
   * Sale: compare_at_price -> price
   * No sale: price only
   */
  if (regularCompareEl) {
    if (isOnSale) {
      regularCompareEl.textContent = this.formatMoney(compareAtPrice);
      regularCompareEl.hidden = false;
    } else {
      regularCompareEl.textContent = '';
      regularCompareEl.hidden = true;
    }
  }

  if (regularCurrentEl) {
    regularCurrentEl.textContent = this.formatMoney(price);
  }

  /*
   * Member Price
    * Sale: current sale price -> discounted member price
    * No sale: discounted member price only
    */
    if (memberCompareEl) {
      if (isOnSale) {
        memberCompareEl.textContent = this.formatMoney(price);
        memberCompareEl.hidden = false;
      } else {
        memberCompareEl.textContent = '';
        memberCompareEl.hidden = true;
      }
    }

    if (memberCurrentEl) {
      memberCurrentEl.textContent = this.formatMoney(memberPrice);
    }

    if (this.stickyPrice) {
      this.stickyPrice.classList.remove('hidden');
      this.stickyPrice.classList.toggle('is-sale', isOnSale);
    }

    if (this.stickyMemberPrice && this.vipDiscount > 0) {
      this.stickyMemberPrice.classList.remove('hidden');
      this.stickyMemberPrice.classList.toggle('is-sale', isOnSale);
    }

    if (this.stickyComparePrice) {
      this.stickyComparePrice.classList.add('hidden');
    }
  }
  syncPriceFromPdp() {
    if (!this.sticky) return;

    const pdpRegular = document.querySelector(
      '[data-vip-regular-price]'
    );

    const pdpMember = document.querySelector(
      '[data-vip-member-price]'
    );

    if (!pdpRegular && !pdpMember) return;

    const copyPriceParts = (
      source,
      compareTarget,
      currentTarget
    ) => {
      if (!source) return;

      const compareSource = source.querySelector(
        '.pdp-pricing-option__compare-price'
      );

      const currentSource =
        source.querySelector(
          '.pdp-pricing-option__sale-price'
        ) ||
        source.querySelector('.price-item') ||
        source;

      if (compareTarget) {
        if (
          compareSource &&
          compareSource.textContent.trim()
        ) {
          compareTarget.textContent =
            compareSource.textContent.trim();

          compareTarget.hidden = false;
        } else {
          compareTarget.textContent = '';
          compareTarget.hidden = true;
        }
      }

      if (currentTarget && currentSource) {
        currentTarget.textContent =
          currentSource.textContent.trim();
      }
    };

    const regularCompareEl = this.sticky.querySelector(
      '.pdp-sticky-atc__regular-compare-price'
    );

    const regularCurrentEl = this.sticky.querySelector(
      '.pdp-sticky-atc__regular-current-price'
    );

    const memberCompareEl = this.sticky.querySelector(
      '.pdp-sticky-atc__member-compare-price'
    );

    const memberCurrentEl = this.sticky.querySelector(
      '.pdp-sticky-atc__member-current-price'
    );

    copyPriceParts(
      pdpRegular,
      regularCompareEl,
      regularCurrentEl
    );

    copyPriceParts(
      pdpMember,
      memberCompareEl,
      memberCurrentEl
    );
  }

  bindPdpPriceObserver() {
    const regularSource = document.querySelector(
      '[data-vip-regular-price]'
    );

    const memberSource = document.querySelector(
      '[data-vip-member-price]'
    );

    if (!regularSource && !memberSource) return;

    const observer = new MutationObserver(() => {
      this.syncPriceFromPdp();
    });

    if (regularSource) {
      observer.observe(regularSource, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (memberSource) {
      observer.observe(memberSource, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    this.syncPriceFromPdp();
  }
  updateImage(variant) {
    if (!this.stickyImage) return;

    const imageSrc = this.getVariantImageSrc(variant);

    if (!imageSrc) return;

    this.stickyImage.src = this.getSizedImageUrl(imageSrc, 120);
    this.stickyImage.alt = variant.featured_image?.alt || this.productJson?.title || this.stickyImage.alt;
  }

  getVariantImageSrc(variant) {
    if (!variant) return '';

    if (variant.featured_image?.src) {
      return variant.featured_image.src;
    }

    if (variant.featured_image?.preview_image?.src) {
      return variant.featured_image.preview_image.src;
    }

    if (variant.featured_media?.preview_image?.src) {
      return variant.featured_media.preview_image.src;
    }

    return '';
  }

  getSizedImageUrl(src, width) {
    if (!src) return '';

    if (src.includes('width=')) {
      return src;
    }

    const separator = src.includes('?') ? '&' : '?';

    return `${src}${separator}width=${width}`;
  }

  formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }

    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  needsOptionSelection() {
    this.selectTeasButton = this.getSelectTeasButton();

    if (this.selectTeasButton) {
      return true;
    }

    const variantInput =
      this.productForm?.querySelector('input[name="id"]') ||
      this.mainProductContainer?.querySelector('input[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (variantInput && variantInput.value) {
      return false;
    }

    const container = this.mainProductContainer || document;

    const optionRadios = container.querySelectorAll(
      '.product-form__input input[type="radio"], input[type="radio"][name^="options"], input[type="radio"][name^="option"]'
    );

    if (optionRadios.length) {
      const groups = {};

      optionRadios.forEach((radio) => {
        if (!groups[radio.name]) {
          groups[radio.name] = false;
        }

        if (radio.checked) {
          groups[radio.name] = true;
        }
      });

      return Object.values(groups).some((selected) => !selected);
    }

    const optionSelects = container.querySelectorAll(
      'select[name^="options"], select[name^="option"]'
    );

    if (optionSelects.length) {
      return Array.from(optionSelects).some((select) => !select.value);
    }

    return false;
  }

  updateButtonState() {
    if (!this.stickyButton) return;
    if (this.isAdding) return;

    this.refreshDynamicElements();

    if (this.needsOptionSelection()) {
      this.stickyButton.disabled = false;
      this.stickyButton.textContent = 'Select Options';
      this.stickyButton.classList.add('is-select-options');
      this.stickyButton.classList.remove('is-disabled', 'is-sold-out', 'is-notify');
      this.setQuantityDisabled(false);
      return;
    }

    const selectedVariant = this.getSelectedVariant();

    const isVariantUnavailable =
      selectedVariant && selectedVariant.available === false;

    const isOutOfStockTagButton =
      this.outOfStockButton &&
      !this.notifyButton;

    const isMainDisabled =
      this.mainAddButton?.disabled ||
      this.mainAddButton?.getAttribute('aria-disabled') === 'true' ||
      this.mainAddButton?.classList.contains('disabled');

    const mainButtonText = this.mainAddButton?.textContent?.trim();

    if (isVariantUnavailable && this.notifyButton) {
      const notifyText = this.notifyButton.textContent?.trim() || 'Email When Available';

      this.stickyButton.disabled = false;
      this.stickyButton.textContent = notifyText;
      this.stickyButton.classList.add('is-sold-out', 'is-notify');
      this.stickyButton.classList.remove('is-disabled', 'is-select-options');
      this.setQuantityDisabled(true);
      return;
    }

    if (isVariantUnavailable || isOutOfStockTagButton || isMainDisabled) {
      const disabledText =
        this.outOfStockButton?.textContent?.trim() ||
        mainButtonText ||
        'Sold Out';

      this.stickyButton.disabled = true;
      this.stickyButton.textContent = disabledText;
      this.stickyButton.classList.add('is-disabled', 'is-sold-out');
      this.stickyButton.classList.remove('is-notify', 'is-select-options');
      this.setQuantityDisabled(true);
      return;
    }

    this.stickyButton.disabled = false;
    this.stickyButton.textContent = mainButtonText || this.addToBagText || 'Add to Bag';
    this.stickyButton.classList.remove('is-disabled', 'is-sold-out', 'is-notify', 'is-select-options');
    this.setQuantityDisabled(false);
  }

  scrollToOptions() {
    this.selectTeasButton = this.getSelectTeasButton();

      const target =
        this.selectTeasButton ||
        this.optionsTarget ||
        this.productForm;

      if (!target) return;

      const offset = 130;
      const top = 0;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });

      window.setTimeout(() => {
        if (typeof target.focus === 'function') {
          target.focus({ preventScroll: true });
        }
      }, 350);
    }
}

document.addEventListener('DOMContentLoaded', () => {
  new PDPStickyAddToCart();
});
document.addEventListener('vipPricing:changed', (event) => {
    const memberSelected = Boolean(event?.detail?.memberSelected);

    const sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;

    const memberPrice = sticky.querySelector(
      '[data-sticky-atc-member-price]'
    );

    const regularPrice = sticky.querySelector(
      '[data-sticky-atc-price]'
    );

    sticky.classList.toggle(
      'is-member-price-selected',
      memberSelected
    );

    if (memberPrice) {
      memberPrice.hidden = !memberSelected;
    }

    if (regularPrice) {
      regularPrice.hidden = memberSelected;
    }
  });